(() => {
  const renderNotifyPopupDate = () => {
    const text = window.__aw26ExpectedAvailability;
    if (!text) return;
    const form = document.querySelector('#formContainer');
    const description = form?.querySelector('#form-Description');
    if (!form || !description) return;
    description.textContent = 'Get a notification as soon as this product is available.';
    let note = form.querySelector('[data-aw26-expected-availability]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.aw26ExpectedAvailability = 'true';
      note.style.cssText = 'margin:12px 0 0;font-weight:600;color:inherit;';
      description.insertAdjacentElement('afterend', note);
    }
    note.textContent = text;
  };

  const normalizePreorderButtonText = () => {
    const form = document.querySelector('form[action*="/cart/add"]');
    const button = form?.querySelector('button[data-add-to-cart].restock-rocket-preorder-button');
    const plan = form?.querySelector('input[name="selling_plan"]');
    const label = button?.querySelector('[data-add-to-cart-text]');
    if (plan?.value && label && !/pre-?order/i.test(label.textContent || '')) {
      label.textContent = 'Pre-order';
    }
  };

  const normalizeCartShipping = () => {
    document.querySelectorAll('.drawerProductTitle > span:not([class])').forEach((line) => {
      const match = line.textContent?.trim().match(/^Shipping:\s*(.+)$/i);
      if (match) line.textContent = 'Estimated shipping date: ' + match[1];
    });
  };

  const refresh = () => {
    normalizePreorderButtonText();
    renderNotifyPopupDate();
    normalizeCartShipping();
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('change', refresh, true);
  document.addEventListener('variant:change', refresh);
  document.addEventListener('variant:selected', refresh);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    window.setTimeout(() => { queued = false; refresh(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  [0, 250, 1000, 2500].forEach((delay) => window.setTimeout(refresh, delay));
})();
